import { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';

interface UseBookingModalReturn {
  openBooking: (planName?: string) => void;
  BookingModal: React.FC;
}

export const useBookingModal = (productName: string, bookingUrl?: string): UseBookingModalReturn => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState<string>('');

  const openBooking = (planName: string = 'Discovery Call') => {
    setSelectedPlan(planName);
    setIsOpen(true);
  };

  const BookingModal = () => (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Book a Call - {productName}</DialogTitle>
          <DialogDescription>
            {selectedPlan !== 'Discovery Call' && `Selected plan: ${selectedPlan}`}
          </DialogDescription>
        </DialogHeader>
        <div className="w-full h-[600px]">
          {bookingUrl ? (
            <iframe
              src={bookingUrl}
              width="100%"
              height="100%"
              frameBorder="0"
              title="Schedule a call"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-muted rounded-lg">
              <p className="text-muted-foreground">No booking URL configured</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );

  return { openBooking, BookingModal };
};
